import axios from 'axios'

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

export async function setCustomerCookie(customerId: string) {
  return axios.post(
    `${BASE_URL}customer-cookie`,
    { customer_id: customerId },
    { withCredentials: true }
  )
}
